export const HANDLE_MODAL = 'HANDLE_MODAL';
export const HIDE_DIALOG = 'HIDE_DIALOG';
export const ADD_SAMPLE_WIDGET = 'ADD_SAMPLE_WIDGET';
export const WIDGET_THEMING_SUCCESS = 'WIDGET_THEMING_SUCCESS';
export const WIDGET_THEMING_FAILURE = 'WIDGET_THEMING_FAILURE';
export const GET_WIDGET_THEMING = 'GET_WIDGET_THEMING';
export const GET_WIDGET_THEMING_SUCCESS = 'GET_WIDGET_THEMING_SUCCESS';
export const GET_WIDGET_THEMING_FAILURE = 'GET_WIDGET_THEMING_FAILURE';
export const NAVIGATE_TRADE_REPORT = 'NAVIGATE_TRADE_REPORT';
export const POPUP_WINDOW_HANDLE = 'POPUP_WINDOW_HANDLE';
export const POPUPCLOSE_HANDLE = 'POPUPCLOSE_HANDLE';
export const LOAD_NEWSFEED = 'LOAD_NEWSFEED';
export const LOAD_NEWSFEED_SUCCESS = 'LOAD_NEWSFEED_SUCCESS';
export const LOAD_NEWSFEED_FAILURE = 'LOAD_NEWSFEED_FAILURE';
export const UPDATE_NEWSFEED ='UPDATE_NEWSFEED';
export const FORCED_LOGOUT = 'FORCED_LOGOUT';
export const CL_FORCED_LOGOUT='CL_FORCED_LOGOUT';
export const KILL_SESSION='KILL_SESSION';
export const NOCHANGE='NOCHANGE';
export const LOAD_LOCK_FLAG='LOAD_LOCK_FLAG';
export const CLEAR_KILL_SESSION='CLEAR_KILL_SESSION';
export const CHANGE_CALENDAR_FLAG ='CHANGE_CALENDAR_FLAG';
export const LOG_FILE_CREATE ='LOG_FILE_CREATE';
export const SEND_LOG = 'SEND_LOG';
export const SEND_LOG_SUCCESS = 'SEND_LOG_SUCCESS';
export const SEND_LOG_FAILURE = 'SEND_LOG_FAILURE';
export const SHOW_DIALOG ='SHOW_DIALOG';
export const RESET_PASSWORD_FLAG = 'RESET_PASSWORD_FLAG';

export const GET_NONTRADEDSTK_LIST='GET_NONTRADEDSTK_LIST';
export const GET_NONTRADEDSTK_LIST_SUCCESS='GET_NONTRADEDSTK_LIST_SUCCESS';
export const GET_NONTRADEDSTK_LIST_FAILURE='GET_NONTRADEDSTK_LIST_FAILURE';

export const LOADING_ON='LOADING_ON';
export const LOADING_OFF='LOADING_OFF';
export const HIDE_MODAL ='HIDE_MODAL';
// export const SUCCESS_DEFAULT = 'SUCCESS_DEFAULT';
// export const FAILURE_DEFAULT = 'FAILURE_DEFAULT';

const LOAD = 'LOAD';
const LOAD_SUCCESS = 'LOAD_SUCCESS';
const CHANGE ='CHANGE';
const LOAD_FAIL = 'LOAD_FAIL';
const LOGIN = 'LOGIN';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAIL = 'LOGIN_FAIL';
const LOGOUT = 'LOGOUT'; // Uncomment this upon connecting with logout api
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
const LOGOUT_FAIL = 'LOGOUT_FAIL';// Uncomment this upon connecting with logout api
const ACCEPT='ACCEPT';
const ACCEPT_SUCCESS='ACCEPT_SUCCESS';
const ACCEPT_FAIL='ACCEPT_FAIL';
const DECLINE='DECLINE';
const DECLINE_SUCCESS='DECLINE_SUCCESS';
const DECLINE_FAIL='DECLINE_FAIL';
const HANDLE_SESSION = 'HANDLE_SESSION';
const KILL_LOGOUT = 'KILL_LOGOUT';// Uncomment this upon connecting with logout api
const LOAD_CHANGE_PASSWORD_SUCCESS='LOAD_CHANGE_PASSWORD_SUCCESS';
const RESETPASS_FLAG='RESETPASS_FLAG';
const FORCED_LOGOUT_CLOSED='FORCED_LOGOUT_CLOSED';
const LOGIN_MESSAGE='LOGIN_MESSAGE';
const RSET_LOGIN_LOADER_FLAG='RSET_LOGIN_LOADER_FLAG';
